import { Tabs } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import PriceSettings from "./tabItems/PriceSettings";

export const settingsTabConfig = {
    PRICE: "1",
    COMMON: "2"
}

const SettingsTab = () => {
    const [currentTab, setCurrentTab] = useState(settingsTabConfig.PRICE);
    const [tabTada, setTabData] = useState({});
    const dispatch = useDispatch();

    useEffect(() => {

    }, [])

    const onSwitchTab = (key, data) => {
        setCurrentTab(key);
    } 

    const tabs = [
        {
          key: settingsTabConfig.PRICE,
          label: 'Price Settings',
          children: <PriceSettings onSwitchTab={onSwitchTab} />,
        },
        // {
        //     key: settingsTabConfig.COMMON,
        //     label: 'Other Settings',
        //     // children: <AddCategory onSwitchTab={onSwitchTab} tabProps={{}} />,
        //     children: <></>,
        // }
    ];

    const onChange = (key) => {
        setCurrentTab(key);
        if (key !== settingsTabConfig.PRICE) {

        }
    };

    return (
        <div>
            <div className="text-2xl pb-3">Settings</div>
            <div className="px-4 border pb-6 bg-white pop-left">
                <Tabs defaultActiveKey="1" activeKey={currentTab} items={tabs} onChange={onChange} />
            </div>
        </div>
    )
}

export default SettingsTab;